module.exports = __webpack_public_path__ + "static/img/296_TO8_1697.def5281.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/296_TO8_1697.jpg
// module id = eiy5
// module chunks = 0